import {
  catalogCategoryPermissionRead,
  catalogProductPermissionRead,
  companyCompanyPermissionRead,
  configurationConfigurationPermissionRead,
  dictionaryDictionaryPermissionRead,
  employeeEmployeePermissionRead,
  employeeEmployeePermissionWrite,
  operatorOperatorPermissionRead,
  ssoIpAddressRestrictionPermissionRead,
  tourismTourismAttributePermissionRead,
  tourismTourismObjectPermissionRead,
  // translationTranslateCmsPermissionWrite,
  translationTranslatePermissionWrite,
  translationTranslationScopePermissionRead,
  subscriptionActiveFormPermissionRead,
  subscriptionBenefitPermissionRead,
  agreementAgreementPermissionRead,
  notificationAppMessagePermissionRead,
  subscriptionBenefitCategoryPermissionRead,
  magentoECommercePermissionAccess,
  employeeMultisportCardAdministrator,
  notificationSmsPermissionRead,
  companyReportAccessPasswordRead,
  catalogProductCodeTemplatePermissionRead,
  companyMyBenefitActiveRead,
  jobManagerProcessRead,
  employeeGroupProductConfigPermissionRead,
  reportsAhrGraphs,
  proposalsModulePermissionRead,
  totalRewardSettings,
  totalRewardPerkUsersRead,
  totalRewardPerkUsersImportExport,
  totalRewardPerksRead,
  totalRewardPerkCategoriesRead,
  organizationStructureModuleRead,
  organizationStructureEmployeeDataImport,
  organizationStructureEmployeeDataExport,
  absencesModuleRead,
  godPermission,
  companySubscriptionsWaitingRoom,
  payrollRoleAdmin,
  payrollRoleUnitAdmin,
  companyMultisportCardWaitingRoom,
  REPORTS_PERMISSIONS_ALL,
  organizationStructureAreaRead,
  organizationStructureEmployeeDataRead,
  organizationStructureAreaImport,
  organizationStructureAreaExport,
  organizationStructureSyncErrors,
  organizationStructurePositionImportHistoryRead,
  organizationStructureLocalizationImportHistoryRead,
} from "src/utils/RoleBasedSecurity/permissions";
import diagnosticServices from "src/Pages/Diagnostic/services";
import FEATURE_FLAGS from "src/utils/constants/featureFlags";

export const MainNav = [
  {
    icon: "pe-7s-diamond",
    label: "Katalog produktów",
    to: "/product-catalog",
    id: "productCatalog",
    content: [
      {
        icon: "pe-7s-diamond",
        label: "Lista produktów",
        to: "/product-catalog/products",
        id: "productCatalogList",
        aclKey: catalogProductPermissionRead,
      },
      {
        label: "Kategorie biznesowe",
        to: "/product-catalog/business-category",
        id: "businessCategory",
        aclKey: catalogCategoryPermissionRead,
        icon: "pe-7s-network",
      },
      {
        label: "Kategorie abonamentowe",
        to: "/product-catalog/subscription-category",
        id: "subscriptionCategory",
        aclKey: subscriptionBenefitCategoryPermissionRead,
        icon: "pe-7s-network",
      },
      {
        label: "Szablony kuponów",
        to: "/product-catalog/coupon-templates",
        id: "couponTemplates",
        aclKey: catalogProductCodeTemplatePermissionRead,
        icon: "pe-7s-network",
      },
      {
        label: "MyBenefit Active - produkty",
        to: "/product-catalog/discount-codes",
        id: "discountCodes",
        aclKey: catalogProductCodeTemplatePermissionRead,
        icon: "pe-7s-network",
      },
      {
        icon: "pe-7s-folder",
        label: "Karty przedpacone - produkty",
        to: "/product-catalog/prepaid-cards",
        id: "prepaidCardsList",
        aclKey: catalogProductPermissionRead,
      },
    ],
  },
  {
    icon: "pe-7s-shuffle",
    label: "Lista dostawców",
    to: "/suppliers",
    id: "suppliers",
    aclKey: tourismTourismObjectPermissionRead,
    isAnchor: true,
  },
  {
    label: "Turystyka",
    to: "/tourism",
    id: "tourism",
    icon: "pe-7s-map",
    content: [
      {
        label: "Lista obiektów",
        to: "/tourism/objects",
        id: "tourismListOfObjects",
        aclKey: tourismTourismObjectPermissionRead,
        tileIcon: "pe-7s-home",
      },
      {
        label: "Lista dostawców",
        to: "/tourism/suppliers",
        id: "tourismListOfSuppliers",
        aclKey: tourismTourismObjectPermissionRead,
        tileIcon: "pe-7s-box2",
      },
      {
        label: "Zarządzanie atrybutami filtrowania",
        to: "/tourism/managing-filtering-attributes",
        id: "tourismManagingFilteringAttributes",
        aclKey: tourismTourismAttributePermissionRead,
        tileIcon: "pe-7s-edit",
      },
      {
        label: "Diagnostyka",
        to: "/tourism/diagnostics",
        id: "tourismDiagnostics",
        aclKey: tourismTourismAttributePermissionRead,
        tileIcon: "pe-7s-edit",
      },
    ],
  },
  {
    icon: "pe-7s-id",
    label: "Firma",
    id: "company",
    to: "/company",
    content: [
      {
        label: "Lista firm",
        to: "/company/list",
        id: "companyList",
        aclKey: companyCompanyPermissionRead,
        tileIcon: "pe-7s-id",
      },
      {
        label: "Lista pracowników",
        to: "/company/employee-list",
        id: "employeeList",
        aclKey: employeeEmployeePermissionRead,
        tileIcon: "pe-7s-users",
      },
      {
        icon: "pe-7s-download",
        label: "SFTP - Import pracowników",
        to: "/import-sftp",
        id: "importSftp",
        aclKey: employeeEmployeePermissionWrite,
      },
      {
        label: "Lista abonamentów",
        to: "/company/subscription-benefits",
        id: "subscriptionBenefits",
        aclKey: subscriptionBenefitPermissionRead,
        tileIcon: "pe-7s-diamond",
      },
    ],
  },
  {
    icon: "pe-7s-tools",
    label: "Administracja",
    id: "administration",
    to: "/administration",
    content: [
      {
        label: "Parametry konfiguracyjne",
        to: "/administration/configuration",
        id: "configuration",
        aclKey: configurationConfigurationPermissionRead,
        tileIcon: "pe-7s-config",
      },
      {
        label: "Słowniki",
        to: "/administration/dictionary",
        id: "dictionary",
        aclKey: dictionaryDictionaryPermissionRead,
        tileIcon: "pe-7s-config",
      },
      {
        label: "Konfiguracja adresów IP",
        to: "/administration/ip-security",
        id: "ipSecurity",
        aclKey: ssoIpAddressRestrictionPermissionRead,
        tileIcon: "pe-7s-unlock",
        notDisplay: true,
      },
      {
        label: "Szablony podpięć EGP",
        to: "/administration/egp-templates",
        id: "egpTemplate",
        aclKey: employeeGroupProductConfigPermissionRead,
        tileIcon: "pe-7s-config",
      },
    ],
  },
  {
    icon: "pe-7s-user",
    label: "Operatorzy MB",
    to: "/user",
    id: "operators",
    content: [
      {
        tileIcon: "pe-7s-user",
        label: "Lista operatorów",
        to: "/user/operator",
        id: "operatorList",
        aclKey: operatorOperatorPermissionRead,
      },
      {
        tileIcon: "pe-7s-users",
        label: "Lista ról",
        to: "/user/role",
        id: "operatorRoleList",
        aclKey: operatorOperatorPermissionRead,
      },
    ],
  },
  // Module probably to delete
  // {
  //   icon: 'pe-7s-box2',
  //   label: 'CMS',
  //   to: '/cms/management',
  //   isAnchor: true,
  //   id: 'cms',
  //   aclKey: cmsDocumentPermissionRead,
  // },
  {
    icon: "pe-7s-note2",
    label: "Formularze aktywne",
    to: "/active-forms",
    id: "activeForms",
    aclKey: subscriptionActiveFormPermissionRead,
  },
  {
    icon: "pe-7s-graph2",
    label: "Raporty",
    id: "report",
    to: "/report",
    content: [
      {
        label: "Raporty",
        to: "/report/predefined-reports",
        id: "new_report",
        tileIcon: "pe-7s-graph1",
      },
      {
        label: "Raporty graficzne",
        to: "/report/graph-reports",
        id: "graph_report",
        tileIcon: "pe-7s-graph",
      },
      {
        label: "Twoje raporty/Archiwum",
        to: "/report/archive",
        id: "archive",
        tileIcon: "pe-7s-chat",
      },
      {
        label: "Aktywne wysyłki",
        to: "/report/subscriptions",
        id: "subscriptions",
        tileIcon: "pe-7s-edit",
      },
    ],
  },
  {
    icon: "pe-7s-check",
    label: "Zgody",
    to: "/agreements",
    id: "agreements",
    aclKey: agreementAgreementPermissionRead,
    content: [
      {
        label: "Zgody",
        to: "/agreements/predefined-agreements",
        id: "predefinedAgreements",
        aclKey: agreementAgreementPermissionRead,
        tileIcon: "pe-7s-check",
      },
      {
        label: "Ewidencja wysłanych regulaminów",
        to: "/agreements/sent-regulations",
        id: "sentRegulations",
        aclKey: agreementAgreementPermissionRead,
        tileIcon: "pe-7s-check",
      },
    ],
  },
  {
    icon: "pe-7s-comment",
    label: "Powiadomienia",
    id: "notification",
    to: "/notification",
    content: [
      {
        label: "Wiadomości wewnątrzsystemowe",
        to: "/notification/app-messages",
        id: "appMessages",
        aclKey: notificationAppMessagePermissionRead,
        tileIcon: "pe-7s-chat",
      },
      {
        label: "Wiadomości SMS",
        to: "/notification/sms",
        id: "sms",
        aclKey: notificationSmsPermissionRead,
        tileIcon: "pe-7s-phone",
      },
    ],
  },
  {
    icon: "pe-7s-notebook",
    label: "Tłumaczenia",
    id: "translate",
    to: "/translate",
    content: [
      {
        label: "Tłumaczenia interfejsu",
        to: "/translate/interface",
        id: "translateInterface",
        aclKey: translationTranslatePermissionWrite,
        tileIcon: "pe-7s-monitor",
      },
      {
        label: "Tłumaczenia wartości prostych",
        to: "/translate/simple",
        id: "translateSimple",
        aclKey: translationTranslatePermissionWrite,
        tileIcon: "pe-7s-display1",
      },
      // {
      //   label: 'Tłumaczenia opisów',
      //   to: '/translate/description',
      //   id: 'translateDescription',
      //   aclKey: translationTranslateCmsPermissionWrite,
      //   tileIcon: 'pe-7s-display2',
      // },
      {
        label: "Zakresy tłumaczeń",
        to: "/translate/scopes",
        id: "translateScopes",
        aclKey: translationTranslationScopePermissionRead,
        tileIcon: "pe-7s-albums",
      },
    ],
  },
  {
    icon: "pe-7s-download",
    label: "Importy",
    id: "imports",
    to: "/imports",
    content: [
      //     {
      //       label: 'Import dokumentów CMS',
      //       to: '/imports/cms',
      //       id: 'importCms',
      //       aclKey: cmsDocumentPermissionWrite,
      //       tileIcon: 'pe-7s-config',
      //     },
    ],
  },
  {
    icon: "pe-7s-graph2",
    label: "Diagnostyka",
    id: "diagnostic",
    to: "/diagnostic",
    content: diagnosticServices,
  },
  {
    icon: "pe-7s-display2",
    label: "Standardy",
    id: "standards",
    to: "/standards",
    dev: true,
    content: [
      {
        label: "Grid filtrowalny js",
        to: "/standards/grid/filtrable-js",
        id: "gridFiltrerableJs",
        tileIcon: "pe-7s-config",
      },
      {
        label: "Grid filtrowalny backend",
        to: "/standards/grid/filtrable-backend",
        id: "gridFiltrerableBackend",
        tileIcon: "pe-7s-config",
      },
      {
        label: "Formularze",
        to: "/standards/forms",
        id: "forms",
        tileIcon: "pe-7s-config",
      },
      {
        label: "Zakładki (proste)",
        to: "/standards/tabs/simple",
        id: "tabsSimple",
        tileIcon: "pe-7s-config",
      },
      {
        label: "Zakładki (z zapamiętywaniem)",
        to: "/standards/tabs/with-memo",
        id: "tabsWithMemo",
        tileIcon: "pe-7s-config",
      },
      {
        label: "Zakładki boczne",
        to: "/standards/tabs/sidebar",
        id: "tabsSidebar",
        tileIcon: "pe-7s-config",
      },
    ],
  },
  {
    icon: "pe-7s-shuffle",
    label: "Procesy",
    to: "/processes",
    id: "processes",
    aclKey: jobManagerProcessRead,
    isAnchor: true,
  },
  {
    icon: "pe-7s-shopbag",
    label: "Panel Magento",
    href: process.env.REACT_APP_MAGENTO_ADMIN_URL,
    id: "magento",
    aclKey: magentoECommercePermissionAccess,
  },
];
export const AhrMainNav = [
  {
    icon: "pe-7s-user",
    label: "Pracownicy",
    to: "/ahr/employees",
    isAnchor: true,
    aclKey: employeeEmployeePermissionRead,
    id: "companyEmployee",
    tail: true,
  },
  {
    icon: "pe-7s-user",
    label: "Export i import danych pracowników",
    to: "/ahr/import-export-data",
    functionality: "ENABLE_ORGANIZATION_STRUCTURE",
    featureFlag:
      FEATURE_FLAGS.ORGANIZATION_STRUCTURE_IMPORT_EXPORT_EMPLOYEES_TAB,
    aclKey: [
      organizationStructureEmployeeDataImport,
      organizationStructureEmployeeDataExport,
    ],
    id: "export_import",
    isStructureRequired: true,
  },
  {
    id: "sync-errors",
    icon: "pe-7s-user",
    label: "Błędy synchronizacji",
    to: "/ahr/sync-errors",
    functionality: "ENABLE_ORGANIZATION_STRUCTURE",
    featureFlag: FEATURE_FLAGS.ORGANIZATION_STRUCTURE_SYNC_ERRORS,
    aclKey: organizationStructureSyncErrors,
  },
  {
    label: "Historia importów",
    icon: "pe-7s-download",
    to: "/ahr/imports-history",
    isAnchor: true,
    aclKey: [
      organizationStructureAreaRead,
      organizationStructureEmployeeDataRead,
      organizationStructurePositionImportHistoryRead,
      organizationStructureLocalizationImportHistoryRead,
    ],
    id: "importsHistory",
    tail: true,
  },
  {
    label: "Benefity oczekujące",
    icon: "pe-7s-cup",
    to: "/ahr/pending-benefits",
    aclKey: [companySubscriptionsWaitingRoom, companyMultisportCardWaitingRoom],
    id: "pendingBenefits",
    tail: true,
  },
  {
    icon: "pe-7s-graph2",
    label: "Raporty",
    to: "/ahr/report",
    id: "report",
    aclKey: REPORTS_PERMISSIONS_ALL,
    content: [
      {
        label: "Raporty",
        to: "/ahr/report/predefined-reports",
        id: "new_report",
        aclKey: REPORTS_PERMISSIONS_ALL,
        tileIcon: "pe-7s-graph1",
      },
      {
        label: "Raporty graficzne",
        to: "/ahr/report/graph-reports",
        id: "graph_report",
        aclKey: reportsAhrGraphs,
        tileIcon: "pe-7s-graph",
      },
      {
        label: "Twoje Raporty/Archiwum",
        to: "/ahr/report/archive",
        id: "archive",
        aclKey: REPORTS_PERMISSIONS_ALL,
        tileIcon: "pe-7s-chat",
      },
      {
        label: "Aktywne wysyłki",
        to: "/ahr/report/subscriptions",
        id: "subscriptions",
        aclKey: REPORTS_PERMISSIONS_ALL,
        tileIcon: "pe-7s-edit",
      },
    ],
    tail: true,
  },
  {
    icon: "pe-7s-comment",
    label: "Powiadomienia",
    id: "notification",
    to: "/ahr/notification",
    content: [
      {
        label: "Wiadomości wewnątrzsystemowe",
        to: "/ahr/notification/app-messages",
        id: "appMessages",
        aclKey: notificationAppMessagePermissionRead,
        tileIcon: "pe-7s-chat",
      },
    ],
    tail: true,
  },
  {
    icon: "pe-7s-unlock",
    label: "Dostępy",
    id: "access",
    aclKey: companyReportAccessPasswordRead,
    to: "/ahr/access",
    tail: true,
  },
  {
    icon: "pe-7s-user",
    label: "Dashboard",
    to: "/ahr/dashboard",
    isAnchor: true,
    functionality: "ENABLE_DASHBOARD",
    featureFlag: FEATURE_FLAGS.DASHBOARD_VISIBILITY,
    tail: true,
    content: [
      {
        label: "Widżety",
        to: `/ahr/dashboard/widgets`,
        id: "dashboardWidget",
        tileIcon: "pe-7s-user",
        featureFlag: FEATURE_FLAGS.DASHBOARD_WIDGETS,
      },
      {
        label: "Konfiguracja menu",
        to: `/ahr/dashboard/menu-configuration`,
        id: "dashboardMenuConfiguration",
        tileIcon: "pe-7s-user",
        featureFlag: FEATURE_FLAGS.DASHBOARD_MENU_CONFIGURATION,
      },
      {
        label: "Profil użytkownika",
        to: `/ahr/dashboard/employee-profile`,
        id: "dashboardEmployeeProfile",
        tileIcon: "pe-7s-user",
        featureFlag: FEATURE_FLAGS.DASHBOARD_EMPLOYEE_PROFILE,
      },
      {
        label: "Podgląd widoczności modułów",
        to: `/ahr/dashboard/modules-visibility-configuration`,
        id: "dashboardModulesVisibilityConfiguration",
        tileIcon: "pe-7s-user",
        featureFlag: FEATURE_FLAGS.DASHBOARD_MODULES_VISIBILITY_CONFIGURATION,
      },
    ],
  },
  {
    icon: "pe-7s-note2",
    label: "Wnioski i Dofinansowania",
    id: "proposals",
    aclKey: proposalsModulePermissionRead,
    functionality: "ENABLE_PROPOSALS",
    to: "/ahr/proposals",
    tail: true,
    isAnchor: true,
    rerender: true,
  },
  {
    icon: "pe-7s-gym",
    label: "Karty Multisport",
    id: "multisport_cart",
    aclKey: employeeMultisportCardAdministrator,
    href: process.env.REACT_APP_MULTISPORT,
    tail: false,
  },
  {
    icon: "pe-7s-smile",
    label: "MyBenefit Active",
    id: "myb_active",
    aclKey: companyMyBenefitActiveRead,
    functionality: "ENABLE_MYBENEFIT_ACTIVE",
    href: "{MyBenefitActiveUrl}",
    tail: false,
  },
  {
    icon: "pe-7s-smile",
    label: "Imprezy Firmowe",
    id: "companyEvents",
    to: `/ahr/company-events`,
    functionality: "ENABLE_COMPANY_EVENTS",
    tail: true,
  },
  {
    icon: "pe-7s-medal",
    label: "Total Reward Statement",
    id: "totalRewardStatement",
    to: `/ahr/total-reward`,
    functionality: "ENABLE_TOTAL_REWARD_STATEMENT",
    tail: true,
    content: [
      {
        label: "Przydzielone Benefity",
        id: "view_totalRewardPerkUsers",
        to: `/ahr/total-reward/perk-users`,
        tileIcon: "pe-7s-note2",
        aclKey: totalRewardPerkUsersRead,
      },
      {
        label: "Import/export benefitów",
        id: "view_totalRewardImportExportPerkUsers",
        to: `/ahr/total-reward/perkusers-import`,
        tileIcon: "pe-7s-repeat",
        aclKey: totalRewardPerkUsersImportExport,
      },
      {
        label: "Zarządzanie benefitami",
        id: "view_totalRewardPerks",
        to: `/ahr/total-reward/perks`,
        tileIcon: "pe-7s-tools",
        aclKey: totalRewardPerksRead,
      },
      {
        label: "Zarządzanie kategoriami",
        id: "view_totalRewardCategories",
        to: `/ahr/total-reward/categories`,
        tileIcon: "pe-7s-drawer",
        aclKey: totalRewardPerkCategoriesRead,
      },
      {
        icon: "pe-7s-settings",
        label: "Ustawienia modułu",
        id: "view_totalRewardSettings",
        to: `/ahr/total-reward/settings`,
        aclKey: totalRewardSettings,
        tileIcon: "pe-7s-settings",
      },
    ],
  },
  {
    label: "Struktura Organizacji",
    to: `/ahr/organization-structure`,
    id: "organization_structure",
    icon: "pe-7s-graph1",
    functionality: "ENABLE_ORGANIZATION_STRUCTURE",
    featureFlag: FEATURE_FLAGS.ORGANIZATION_STRUCTURE,
    aclKey: organizationStructureModuleRead,
    content: [
      {
        label: "Konfiguracja Struktury",
        id: "structure_configuration",
        to: `/ahr/organization-structure/configure-structure`,
        tileIcon: "pe-7s-edit",
        aclKey: organizationStructureModuleRead,
      },
      {
        label: "Lokalizacje",
        id: "localizations",
        to: `/ahr/organization-structure/localizations`,
        tileIcon: "pe-7s-download",
        featureFlag: FEATURE_FLAGS.ORGANIZATION_STRUCTURE_LOCALIZATIONS,
        isStructureRequired: true,
      },
      {
        label: "Import/Eksport lokalizacji",
        id: "importExportLocalizations",
        to: `/ahr/organization-structure/localizations/import-export-localizations`,
        tileIcon: "pe-7s-download",
        featureFlag:
          FEATURE_FLAGS.ORGANIZATION_STRUCTURE_LOCALIZATIONS_IMPORT_EXPORT_TAB,
        notDisplay: true,
      },
      {
        label: "Stanowiska",
        id: "positions",
        to: `/ahr/organization-structure/positions`,
        tileIcon: "pe-7s-download",
        featureFlag: FEATURE_FLAGS.ORGANIZATION_STRUCTURE_POSITIONS,
        isStructureRequired: true,
      },
      {
        label: "Import/export danych obszaru",
        id: "import-export-area-data",
        to: `/ahr/organization-structure/import-export-area-data`,
        tileIcon: "pe-7s-download",
        isStructureRequired: true,
        notDisplay: true,
        featureFlag:
          FEATURE_FLAGS.ORGANIZATION_STRUCTURE_IMPORT_EXPORT_EMPLOYEES_TAB,
        functionality: "ENABLE_ORGANIZATION_STRUCTURE",
        aclKey: [
          organizationStructureAreaImport,
          organizationStructureAreaExport,
        ],
      },
    ],
  },
  {
    icon: "pe-7s-plane",
    label: "Nieobecności",
    id: "absences",
    to: `/ahr/absences`,
    functionality: "ENABLE_ABSENCE_MODULE",
    aclKey: absencesModuleRead,
    featureFlag: FEATURE_FLAGS.ABSENCES,
    dataTestId: "absences-menu-item",
  },
  {
    icon: "pe-7s-smile",
    label: "Moduł Wynagrodzeń",
    id: "payroll_module",
    functionality: "ENABLE_PAYROLL_MODULE",
    href: "{PayrollModuleUrl}",
    tail: true,
    isTargetBlank: true,
    aclKey: [payrollRoleAdmin, payrollRoleUnitAdmin],
    featureFlag: FEATURE_FLAGS.PAYROLL_MODULE,
  },
  {
    icon: "pe-7s-back",
    label: "Powrót do Dashboardu",
    id: "back_to_mb_dashboard",
    href: `{mbDashboardUrl}`,
    functionality: "ENABLE_DASHBOARD",
    tail: true,
    before: "back_to_pwa",
  },
  {
    icon: "pe-7s-shopbag",
    label: "Powrót do Systemu Kafeteryjnego",
    id: "back_to_pwa",
    href: process.env.REACT_APP_MAGENTO_PWA,
    before: "reimpersonate",
    tail: true,
  },
];
